import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { Catalogue } from "@singularsystems/neo-react-services";
import AssetType from "../../../Models/Catalogue/Classifications/AssetType";

export default class AssetTypeCatalogueEntry extends CatalogueEntry<AssetType> {

    constructor() {
        super("Asset Types", AssetType);
    }

    public get editRole() {
        return CatalogueRoles.AssetTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.assetTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveAssetTypes;
    }

    public renderRow(item: AssetType, meta: Model.TransformMetaType<AssetType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.assetTypeName} />
                <NeoGrid.Column bind={meta.assetTypeCode} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}